var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeutral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188.341,
    height: 188.341,
    viewBox: "0 0 188.341 188.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "neutral",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_440",
    "data-name": "Grupo 440",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_436",
    "data-name": "Grupo 436",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_435",
    "data-name": "Grupo 435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2071_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2072_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2073_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2074_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2075_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2076_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2077_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2078_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2079_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2080_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2081_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2082_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2083_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2084_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2085_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_157",
    "data-name": "Elipse 157",
    cx: 94.17,
    cy: 94.17,
    r: 94.17,
    fill: "#fed940"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_441",
    "data-name": "Grupo 441",
    transform: "translate(46.629 42.017)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_158",
    "data-name": "Elipse 158",
    cx: 14.993,
    cy: 14.993,
    r: 14.993,
    fill: "#634c4c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_159",
    "data-name": "Elipse 159",
    cx: 14.993,
    cy: 14.993,
    r: 14.993,
    transform: "translate(65.099)",
    fill: "#634c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_442",
    "data-name": "Grupo 442",
    transform: "translate(39.767 103.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_599",
    "data-name": "Caminho 599",
    d: "M152.055,274.167H260.864v18.319H152.055Z",
    transform: "translate(-152.055 -274.167)",
    fill: "#634c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_444",
    "data-name": "Grupo 444",
    transform: "translate(94.171 103.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_443",
    "data-name": "Grupo 443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_600",
    "data-name": "Caminho 600",
    d: "M256,274.17h54.407v18.319H256Z",
    transform: "translate(-256 -274.17)",
    fill: "#634c4c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/neutral.f46ab56460a3559905b372fcb233382f.svg";
export { ForwardRef as ReactComponent };